/* istanbul ignore file */
/* tslint:disable */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { NonPresentPreference, NotificationSetting, PatchNotificationSettingUserSettingData, PatchUiPreferenceUserSettingData, PresentPreference, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function userSetting(config) {
    const getAllNotificationSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(NotificationSetting)),
    });
    const patchNotificationSettingResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getUiPreferenceResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([PresentPreference, NonPresentPreference]))),
    });
    const patchUiPreferenceResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    return Object.freeze({
        /**
         * Update preferences for notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.token The token with which you want to get the preferences, if not given the preferences are retrieved for the currently logged in user.
         * @returns The preferences for the user as described by the `token`.
         */
        getAllNotificationSettings: async ({ token = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/settings/notification_settings/`, getAllNotificationSettingsResponse.v, undefined, {
                token,
            });
            return result;
        },
        /**
         * Update preferences for notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @param arg.token The token with which you want to update the preferences, if not given the preferences are updated for the currently logged in user.
         * @returns Nothing.
         */
        patchNotificationSetting: async ({ requestBody, token = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/settings/notification_settings/`, patchNotificationSettingResponse.v, JSON.stringify(PatchNotificationSettingUserSettingData.encode(requestBody)), {
                token,
            });
            return result;
        },
        /**
         * Get ui preferences.
         *
         * @param arg The arguments to the function.
         * @param arg.name The preference name you want to get.
         * @param arg.token The token with which you want to get the preferences, if not given the preferences are retrieved for the currently logged in user.
         * @returns The preferences for the user as described by the `token`.
         */
        getUiPreference: async ({ name = undefined, token = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/settings/ui_preferences/`, getUiPreferenceResponse.v, undefined, {
                name,
                token,
            });
            return result;
        },
        /**
         * Update ui preferences.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @param arg.token The token with which you want to update the preferences, if not given the preferences are updated for the currently logged in user.
         * @returns Nothing.
         */
        patchUiPreference: async ({ requestBody, token = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/settings/ui_preferences/`, patchUiPreferenceResponse.v, JSON.stringify(PatchUiPreferenceUserSettingData.encode(requestBody)), {
                token,
            });
            return result;
        },
    });
}
